import { NavLink } from 'fluxible-router';
import * as React from 'react';
import styles from './styles.module.styl';
export var CuratedCard = function (_a) {
    var category = _a.category, _b = _a.articleCount, articleCount = _b === void 0 ? 3 : _b;
    var articles = category.articles.slice(0, articleCount);
    return (React.createElement("div", { className: "".concat(styles.curatedCard, " col-sm-6 col-md-4") },
        React.createElement("div", { className: styles.curatedCardContainer },
            React.createElement("div", { className: styles.curatedCardLogo },
                React.createElement("img", { src: "/docs/img/curated/".concat(category.id, ".png") })),
            React.createElement("div", { className: "".concat(styles.curatedCardMain) },
                React.createElement("div", { className: styles.curatedCardHeader },
                    React.createElement("h3", null,
                        React.createElement(NavLink, { href: category.url }, category.title)),
                    React.createElement("p", null, category.description)),
                React.createElement("ul", { className: styles.curatedCardArticles }, articles.map(function (article) { return (React.createElement("li", { key: article.url },
                    React.createElement(NavLink, { href: article.url, followLink: article.forceFullReload }, article.title))); })),
                React.createElement(NavLink, { className: styles.curatedCardMore, href: category.url }, "+ More")))));
};
